import fetch from "../fetch";

export default ({ id }) => fetch({ path: `/hy/managers/${id}` });
